import React from 'react';
import PropTypes from 'prop-types';

// import assets
import './quoteModule.scss';

const QuoteModuleView = props => (
  <div className="m-article-module">
    <div className={' m-quote-module'}>
      <div className={'m-quote-module__quote'} dangerouslySetInnerHTML={{ __html: props.children }} />
      <span className={'m-quote-module__cited'}>{props.cited}</span>
    </div>
  </div>
);

QuoteModuleView.propTypes = {
  cited: PropTypes.string,
  children: PropTypes.node.isRequired,
};

QuoteModuleView.defaultProps = {
  cited: '',
};

export default QuoteModuleView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/QuoteModule/QuoteModuleView.jsx